import { useTranslator, useLanguageByUser } from '@picsart/rc/services/localization';
import { LogoTextLight } from '@picsart/cascade/logos';
import { u as useAuthContext } from './authContext-fe8fc8dc.js';
import { _ as _defineProperty } from './defineProperty-377d5a7f.js';
import { _ as _slicedToArray } from './slicedToArray-b4278ecd.js';
import { useState, useRef, useEffect, useCallback } from 'react';
import classnames from 'classnames';
import { useInView } from 'react-intersection-observer';
import { Dropdown, DropdownItem } from '@picsart/rc/old/Dropdown';
import { Button } from '@picsart/rc/old/Button';
import IconCrossLarge from '@picsart/icons/IconCrossLarge';
import AnalyticsService from '@picsart/rc/services/analytics';
import useClickOutside from '@picsart/rc/useClickOutside';
import { languages } from '@picsart/rc/languages';
import IconArrowDownFilled from '@picsart/icons/IconArrowDownFilled';
import IconTickLarge from '@picsart/icons/IconTickLarge';
import { createUseStyles } from 'react-jss';
import '@picsart/cascade/styleHelpers/initFavIcons';
import { t as theme } from './styles-2f14f8fb.js';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import '@picsart/rc/useMount';
import '@picsart/cascade/colors/themes';
import { scrollbar, ScrollbarSkins } from '@picsart/cascade/styleHelpers/scrollbar';
import mediaQuery from '@picsart/cascade/styleHelpers/mediaQuery';
import { BreakPoints } from '@picsart/cascade/responsive';
import { isRightToLeft, isLeftToRight } from '@picsart/cascade/styleHelpers/rtl';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useStyles$2 = createUseStyles(function (_ref) {
  var spacings = _ref.spacings,
    colors = _ref.colors,
    timings = _ref.timings,
    easings = _ref.easings,
    fontWeights = _ref.fontWeights,
    fontSizes = _ref.fontSizes,
    lineHeights = _ref.lineHeights,
    radiuses = _ref.radiuses;
  return {
    root: {},
    label: {
      cursor: 'pointer'
    },
    scrollable: _objectSpread(_objectSpread({
      maxHeight: 'inherit',
      overflowX: 'hidden',
      overflowY: 'auto',
      padding: [spacings.s24, spacings.s0],
      '-webkit-overflow-scrolling': 'touch'
    }, scrollbar({
      skin: ScrollbarSkins.Control,
      width: 2
    })), {}, _defineProperty(_defineProperty(_defineProperty({}, mediaQuery(BreakPoints.Small), {
      padding: spacings.s0,
      height: 'calc(100vh - 140px)'
    }), mediaQuery(766), {
      height: 'calc(100vh - 110px)'
    }), '& ul', {
      listStyle: 'none',
      scrollBehavior: 'smooth'
    })),
    arrowIcon: {
      width: 20,
      height: 20,
      transition: "transform ".concat(timings.Default, " ").concat(easings.EaseInOut),
      position: 'absolute',
      right: 10,
      '& svg': {
        fill: colors.texts.positive
      }
    },
    isOpen: {
      transform: 'rotate(180deg)'
    },
    item: {
      display: 'flex',
      alignItems: 'center',
      margin: spacings.s0,
      textAlign: 'left',
      fontWeight: fontWeights.Regular,
      fontSize: fontSizes.s14,
      color: colors.texts.base,
      position: 'relative',
      padding: [spacings.s8, spacings.s0, spacings.s8, spacings.s40],
      borderRadius: 'initial',
      '&:hover': {
        backgroundColor: colors.backgrounds.base
      }
    },
    selected: {
      '& > svg': {
        width: 20,
        height: 20,
        display: 'block',
        position: 'absolute',
        left: spacings.s12
      }
    },
    dropdownButtonContainer: _defineProperty({
      position: 'relative'
    }, mediaQuery(BreakPoints.Small), {
      position: 'initial'
    }),
    buttons: {
      display: 'flex',
      justifyContent: 'space-between'
    },
    head: {
      position: 'relative',
      border: '1px solid var(--backgrounds-tint-5)',
      color: colors.texts.positive,
      fontWeight: fontWeights.Bold,
      display: 'flex',
      minWidth: 120,
      height: 32,
      justifyContent: 'space-between',
      padding: [spacings.s12, spacings.s0],
      '& span': {
        textAlign: 'center',
        paddingLeft: spacings.s12,
        lineHeight: lineHeights.l24
      },
      '& svg path': {
        fill: colors.backgrounds.tint5
      }
    },
    chooserDropdown: _defineProperty({
      top: 'initial',
      bottom: '100%',
      marginBottom: spacings.s8,
      minWidth: 177,
      maxHeight: 0,
      '& > div': _defineProperty({
        padding: spacings.s0,
        maxHeight: 400
      }, mediaQuery(BreakPoints.Small), {
        borderRadius: radiuses.r0,
        maxHeight: 'initial',
        height: 'initial'
      })
    }, mediaQuery(BreakPoints.Small), {
      transition: 'none'
    }),
    openChooser: _defineProperty({
      borderRadius: radiuses.r8,
      maxHeight: 400
    }, mediaQuery(BreakPoints.Small), {
      position: 'fixed',
      left: spacings.s0,
      right: spacings.s0,
      top: spacings.s0,
      bottom: spacings.s0,
      width: '100%',
      height: '100vh',
      minHeight: '100%',
      transform: 'none',
      borderRadius: radiuses.r0,
      zIndex: 9999,
      backgroundColor: colors.statuses.positive.base.action,
      overflowY: 'auto',
      '& $item': {
        borderTop: "1px solid ".concat(colors.markets.base.active),
        borderRadius: 'initial',
        textAlign: 'left',
        padding: [spacings.s16, spacings.s48],
        margin: spacings.s0
      }
    }),
    active: {
      // TODO replace when this color is refined
      backgroundColor: '#1E2129',
      border: '1px solid #535771',
      '& span': {
        opacity: 0.5
      }
    },
    dropDownHead: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      height: 80,
      padding: [spacings.s0, spacings.s24],
      marginBottom: spacings.s24
    },
    dropDownHeadTitle: {
      fontSize: fontSizes.s24,
      lineHeight: lineHeights.l32,
      color: colors.texts.tint1,
      textTransform: 'capitalize'
    },
    mobileBody: _defineProperty({
      maxHeight: '100%',
      display: 'none'
    }, mediaQuery(BreakPoints.Small), {
      display: 'block'
    }),
    closeDropDown: {
      width: 32,
      height: 32,
      display: 'block',
      backgroundColor: colors.backgrounds.tint6,
      borderRadius: radiuses.r24,
      fill: colors.texts.positive
    }
  };
}, {
  name: 'lang-switcher'
});

var LANGUAGE = 'language';
function FooterLangSwitcher(_ref) {
  var _languages;
  var className = _ref.className,
    isMobile = _ref.isMobile;
  var classes = useStyles$2();
  var translate = useTranslator();
  var _useInView = useInView(),
    ref = _useInView.ref,
    inView = _useInView.inView;
  var _useLanguageByUser = useLanguageByUser(),
    _useLanguageByUser$la = _useLanguageByUser.languagesList,
    languages$1 = _useLanguageByUser$la === void 0 ? languages : _useLanguageByUser$la,
    onChooseLanguage = _useLanguageByUser.onChooseLanguage,
    show = _useLanguageByUser.showLangBar;
  var _useLanguageByUser2 = useLanguageByUser(),
    language = _useLanguageByUser2.currentLanguage,
    setLocale = _useLanguageByUser2.setLocale;
  var _useState = useState({
      value: language,
      name: (_languages = languages$1[language]) === null || _languages === void 0 ? void 0 : _languages.name
    }),
    _useState2 = _slicedToArray(_useState, 2),
    currentLang = _useState2[0],
    setCurrentLang = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showLangBar = _useState4[0],
    setShowLangBar = _useState4[1];
  var currentRef = useRef(null);
  var switcherRef = useRef(null);
  useEffect(function () {
    var _languages2;
    setCurrentLang({
      value: language,
      name: (_languages2 = languages$1[language]) === null || _languages2 === void 0 ? void 0 : _languages2.name
    });
  }, [languages$1, language]);
  useClickOutside(switcherRef, function () {
    setShowLangBar(false);
  });
  var selectLanguage = useCallback(function (_ref2) {
    var name = _ref2.name,
      value = _ref2.value;
    AnalyticsService.sendEvent('page_click', {
      component: 'footer',
      action_button: "language_".concat(name.toLowerCase())
    });
    setCurrentLang({
      name: name,
      value: value
    });
    setShowLangBar(false);
    setLocale(LANGUAGE, value);
    onChooseLanguage && onChooseLanguage(value);
  }, [onChooseLanguage, setLocale]);
  var triggerShowLangBar = useCallback(function () {
    setShowLangBar(function (prev) {
      if (!prev) {
        AnalyticsService.sendEvent('page_click', {
          component: 'footer',
          action_button: 'language_chooser_open'
        });
      }
      return !prev;
    });
  }, []);
  useEffect(function () {
    if (!showLangBar && !isMobile) {
      setTimeout(function () {
        var _currentRef$current;
        currentRef === null || currentRef === void 0 || (_currentRef$current = currentRef.current) === null || _currentRef$current === void 0 || _currentRef$current.scrollTo(0, 0);
      }, 500);
    }
  }, [isMobile, showLangBar]);
  if (!show || !languages$1) return null;
  return /*#__PURE__*/jsx("div", {
    className: classnames(classes.root, className),
    "data-testid": "footer-lang-switcher",
    ref: switcherRef,
    children: /*#__PURE__*/jsx("div", {
      className: classes.buttons,
      ref: ref,
      children: /*#__PURE__*/jsxs("div", {
        className: classes.dropdownButtonContainer,
        children: [/*#__PURE__*/jsxs(Button, {
          secondary: true,
          isResponsive: false,
          className: classnames(classes.head, _defineProperty({}, classes.active, showLangBar)),
          onClick: triggerShowLangBar,
          type: "button",
          children: [/*#__PURE__*/jsx("span", {
            children: currentLang.name
          }), /*#__PURE__*/jsx(IconArrowDownFilled, {
            fill: theme.colors.texts.positive,
            className: classnames(classes.arrowIcon, _defineProperty({}, classes.isOpen, showLangBar)),
            "data-testid": "language-switcher"
          })]
        }), inView && /*#__PURE__*/jsxs(Dropdown, {
          directionUp: isMobile,
          isOpen: showLangBar,
          className: classnames(classes.chooserDropdown, _defineProperty({}, classes.openChooser, showLangBar)),
          children: [/*#__PURE__*/jsx("div", {
            className: classes.mobileBody,
            children: /*#__PURE__*/jsxs("div", {
              className: classes.dropDownHead,
              children: [/*#__PURE__*/jsx("span", {
                className: classes.dropDownHeadTitle,
                children: translate('language')
              }), /*#__PURE__*/jsx(IconCrossLarge, {
                fill: theme.colors.texts.positive,
                onClick: triggerShowLangBar,
                className: classes.closeDropDown
              })]
            })
          }), /*#__PURE__*/jsx("div", {
            className: classes.scrollable,
            ref: currentRef,
            children: /*#__PURE__*/jsx("ul", {
              children: Object.values(languages$1).map(function (language) {
                return /*#__PURE__*/jsx(DropdownItem, {
                  className: classnames(classes.item, currentLang.value === language.value ? classes.selected : ''),
                  selected: currentLang.value === language.value,
                  "data-test": "footerLanguage-currentLang",
                  onClick: function onClick() {
                    return selectLanguage({
                      name: language.name,
                      value: language.value
                    });
                  },
                  label: /*#__PURE__*/jsxs(Fragment, {
                    children: [currentLang.value === language.value && /*#__PURE__*/jsx(IconTickLarge, {
                      fill: theme.colors.accents.primary.base.action
                    }), language.name]
                  })
                }, language.value);
              })
            })
          })]
        })]
      })
    })
  });
}

var LogoDimensions = /*#__PURE__*/function (LogoDimensions) {
  LogoDimensions[LogoDimensions["width"] = 78] = "width";
  LogoDimensions[LogoDimensions["height"] = 16] = "height";
  return LogoDimensions;
}({});
var useStyles$1 = createUseStyles(function (_ref) {
  var spacings = _ref.spacings,
    colors = _ref.colors,
    fontWeights = _ref.fontWeights,
    fontSizes = _ref.fontSizes,
    lineHeights = _ref.lineHeights;
  return {
    root: {
      padding: function padding(props) {
        return props.isMobile ? "".concat(spacings.s0, " ").concat(spacings.s24) : spacings.s0;
      },
      fontSize: 0,
      display: 'flex',
      alignItems: 'center'
    },
    link: {
      display: 'inline-block',
      verticalAlign: 'top',
      height: 16
    },
    logo: {
      display: 'block',
      width: LogoDimensions.width,
      height: LogoDimensions.height,
      opacity: 0.6
    },
    title: _defineProperty(_defineProperty({
      display: 'inline-block',
      fontWeight: fontWeights.Medium,
      fontSize: fontSizes.s16,
      lineHeight: lineHeights.l24,
      color: colors.texts.positive
    }, isLeftToRight(), {
      paddingLeft: spacings.s6
    }), isRightToLeft(), {
      paddingRight: spacings.s6
    }),
    languageSwitcher: {
      marginLeft: spacings.s24
    }
  };
}, {
  name: 'logo-and-switcher'
});

function LogoAndLanguageSwitcher(_ref) {
  var isMobile = _ref.isMobile,
    isSingleLanguage = _ref.isSingleLanguage;
  var styles = useStyles$1({
    isMobile: isMobile
  });
  var translate = useTranslator();
  var _useAuthContext = useAuthContext(),
    user = _useAuthContext.user;
  var url = !user ? '/' : isMobile ? '/feed' : '/create';
  return /*#__PURE__*/jsxs("div", {
    className: styles.root,
    "data-testid": "logo-lang-switcher",
    children: [/*#__PURE__*/jsx("a", {
      className: styles.link,
      href: url,
      tabIndex: 0,
      children: /*#__PURE__*/jsx("img", {
        src: LogoTextLight,
        className: styles.logo,
        "data-test": "picsart-logo",
        alt: translate('Picsart Logo'),
        title: translate('Picsart'),
        width: LogoDimensions.width,
        height: LogoDimensions.height
      })
    }), "Picsart", !isSingleLanguage && /*#__PURE__*/jsx(FooterLangSwitcher, {
      isMobile: isMobile,
      className: styles.languageSwitcher
    })]
  });
}

var useStyles = createUseStyles(function (_ref) {
  var fontWeights = _ref.fontWeights,
    fontSizes = _ref.fontSizes,
    colors = _ref.colors;
  return {
    root: {
      display: 'inline-block',
      verticalAlign: 'top',
      fontWeight: fontWeights.Medium,
      fontSize: fontSizes.s12,
      color: colors.backgrounds.tint3
    }
  };
}, {
  name: 'copyright-footer'
});

function CopyRight() {
  var styles = useStyles();
  return /*#__PURE__*/jsxs("strong", {
    className: styles.root,
    "data-testid": "footer-copyright",
    children: ["\xA9", ' ', new Date().getFullYear(), ' ', "Picsart, Inc."]
  });
}

export { CopyRight as C, FooterLangSwitcher as F, LogoAndLanguageSwitcher as L };
//# sourceMappingURL=CopyRight-a9a10613.js.map
